import useUiuxStore, { ToastType } from 'src/store/useUiuxStore';

export const useToast = () => {
  const { addToast } = useUiuxStore();

  const showToast = (type: ToastType, message: string, duration?: number) => {
    addToast(type, message, duration);
  };

  const success = (message: string, duration?: number) => {
    showToast('success', message, duration);
  };

  const error = (message: string, duration?: number) => {
    showToast('error', message, duration);
  };

  const warning = (message: string, duration?: number) => {
    showToast('warning', message, duration);
  };

  const info = (message: string, duration?: number) => {
    showToast('info', message, duration);
  };

  return {
    showToast,
    success,
    error,
    warning,
    info
  };
}; 